<div class="host-robot-rules">
  @switch (type) {
    @case ("message") {
      <host-message-rules
        [type]="eventType"
        [event]="event"
        [editMode]="editMode"
        [id]="id"
        [listOfHouseOption]="listOfHouseOption"
        [listOfChannelOption]="listOfChannelOption"
        [listOfDynContentOption]="listOfDynContentOption"></host-message-rules>
    }

    @case ("rate") {
      <host-rate-guest-rules
        [id]="id"
        [editMode]="editMode"
        [listOfChannelOption]="listOfChannelOption"
        [listOfDynContentOption]="listOfDynContentOption"></host-rate-guest-rules>
    }

    @case ("rate_reply") {
      <host-reply-guest-rules
        [id]="id"
        [editMode]="editMode"
        [listOfChannelOption]="listOfChannelOption"
        [listOfDynContentOption]="listOfDynContentOption"></host-reply-guest-rules>
    }

    @case ("price") {
      <host-price-rules [editMode]="editMode" [id]="id" [listOfChannelOption]="listOfChannelOption"></host-price-rules>
    }

    @case ("task") {
      <host-task-rules
        [id]="id"
        [editMode]="editMode"
        [taskType]="taskType"
        [listOfDynContentOption]="listOfDynContentOption"></host-task-rules>
    }

    @case ("gap") {
      <host-gap-rules [id]="id" [editMode]="editMode" [listOfChannelOption]="listOfChannelOption"></host-gap-rules>
    }
  }
</div>
